
import { ProfileServicesService } from '../services/profile-services.service';
import { ProfileModel } from '../models/ProfileModel';
import { RequestPhotoUpdate } from '../models/requestPhotoUpdate';
import { LoaderImageComponent } from '../utils/loader-image/loader-image.component';
import { ProfilePhotoComponent } from "../utils/profile-photo/profile-photo.component";

import { ImageCroppedEvent, ImageCropperComponent } from 'ngx-image-cropper';
import { LoginUserModel } from '../models/loginUserModel';
import { DomSanitizer } from '@angular/platform-browser';
import { OnInit, AfterViewInit, Component, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormControl } from '@angular/forms';
import { OutsideClickDirective } from '../outside-click.directive';
import { DataSharingService } from '../data-sharing.service';
import { ButtonModule } from 'primeng/button';
import { AvatarComponent } from '../utils/avatar/avatar.component';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { CommonModule } from '@angular/common';



@Component({
    selector: 'app-client-profile',
    imports: [ButtonModule, AvatarComponent, InputTextModule, DialogModule, TooltipModule, ReactiveFormsModule, FormsModule, LoaderImageComponent, ProfilePhotoComponent, ImageCropperComponent,CommonModule],
    templateUrl: './client-profile.component.html',
    styleUrl: './client-profile.component.scss'
})
export class ClientProfileComponent implements OnInit, AfterViewInit {
  formProfile !: FormGroup;
  photoUuid: string | null = null;
  isImageLoaded: boolean = false;
  profileError = false;
  imageProfile: any = '';
  showProfileImage = false;
  imageChangedEvent: any;
  base64: any;
  showCropper = false;
  data!:LoginUserModel;
  firstTime: boolean = true;
  tokenAuth=""; 
  @ViewChild("cropperDiv") imageCropper!: ImageCropperComponent;
  constructor(private service: ProfileServicesService, private sanitizer: DomSanitizer,private dataSharingService: DataSharingService) {

    this.data = JSON.parse(localStorage.getItem('data')!); 
    this.formProfile = new FormGroup({
      usuario: new FormControl({ value: '', disabled: true }),
      tipoAcceso: new FormControl({ value: '', disabled: true }),
      estado: new FormControl({ value: '', disabled: true }),
      noCliente: new FormControl({ value: '', disabled: true }),
      direccion: new FormControl({ value: '', disabled: true }),
      email: new FormControl({ value: '', disabled: true }),
      tipoCompra: new FormControl({ value: '', disabled: true }),
      dispositivos: new FormControl({ value: '', disabled: true }),
      rfc: new FormControl({ value: '', disabled: true }),
      telefono: new FormControl({ value: '', disabled: true }),
    })
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    this.cargaImagePerfil();
    this.cargaPerfil();
  }

  cargaPerfil() {
    this.service.loadProfile(this.data.Client_number, this.data.User_id).subscribe({
      next: (data: ProfileModel) => {
        this.formProfile.get('usuario')?.setValue(data.name);
        this.formProfile.get('tipoAcceso')?.setValue(data.userType);
        this.formProfile.get('estado')?.setValue(data.status == 1 ? 'Activo' : ' Inactivo');
        this.formProfile.get('noCliente')?.setValue(data.number);
        this.formProfile.get('direccion')?.setValue(data.address);
        this.formProfile.get('email')?.setValue(data.email);
        this.formProfile.get('tipoCompra')?.setValue(data.purchaseType);
        this.formProfile.get('dispositivos')?.setValue(data.card);
        this.formProfile.get('rfc')?.setValue(data.rfc);
        this.formProfile.get('telefono')?.setValue(data.phone);

      },
      error: (err: any) => {
        this.profileError = true;
      }
    });


  }

  cargaImagePerfil() {
    this.isImageLoaded = false;
    this.service.loadUserImage(this.data.Client_number, this.data.User_id).subscribe({
      next: (resp: RequestPhotoUpdate) => {
        if (!resp.image) {
          this.imageProfile = '';
          this.isImageLoaded = true;
          return;
        }
        if (resp.isMongo) {
          this.service.loadImageMongo(resp.image).subscribe({
            next: (data: any) => {
              this.imageProfile = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
              this.isImageLoaded = true;
            },
            error: () => { this.isImageLoaded = true; }
          });
        } else {
          this.imageProfile = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + resp.image);
          this.isImageLoaded = true;
        }
      },
      error: () => { this.isImageLoaded = true; }
    });
  }

  showPhoto() {
    this.showProfileImage=true;
  }

  fileChangeEvent(event: Event): void {
    if(event.target){
      this.showCropper = true;
      this.imageChangedEvent = event;
    }
  }
  
  imageCropped(event: ImageCroppedEvent) {
    this.imageProfile = this.sanitizer.bypassSecurityTrustUrl(event.base64!);
    this.saveFileMongo(event.base64!);    
  }

  imageLoaded(image: any) {
    this.imageChangedEvent.target.value='';
  }

  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
    this.showCropper = false;
  }

  doCrop() {
    this.imageCropper.crop();
    this.showCropper= false;
  }

  saveFileMongo(base64Img:string){
    this.service.saveMongoImage(base64Img,'fotoPerfil_'+this.data.Client_number).subscribe({
      next:(response:any)=>{
        if(response.fileId){
          this.saveUserImage(response.fileId);
          this.dataSharingService.imageSource.next(base64Img)
        }
      },
      error:(err:any)=>{
        
      }
    })
  }

  saveUserImage(fileId:string){
    this.service.saveProfileImageUser(fileId,this.data.Client_number,this.data.UserType=='Administrator'?0:this.data.User_id).subscribe({
      next:(resp:RequestPhotoUpdate)=>{
        if(resp.isMongo==true){
          this.showCropper = false;     
        }
      },error:(erro)=>{        
       
      }
    })
  }

  clickOutside(isOut: any) {
     if(isOut){
      this.showCropper=false;
    }
  }

  clickOutside_(isOut: any) {
    if (isOut && !this.firstTime) {
      this.showProfileImage = false;
      this.firstTime = true;
    }
    else{
    this.firstTime = false;
    }
  }  
}



